import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { Location, SectionsInfo } from "../../Services";
// import { EsfLocation, StationInfo } from "../../Services/Agrisys_GqlDataCaller/WalkThroughDataCalls/getEsfStructureCall";
import { Location, SectionsInfo } from "../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLfStructureCall";

type ActivePen =
  | {
      type: "lf";
      location: Location;
      group: SectionsInfo;
      system: number;
    }
  | {
      type: "esf";
      location: number;
      group: number;
      system: number;
    };

interface ModalRedirectState {
  activePen: ActivePen | null;
}

const initialState: ModalRedirectState = {
  activePen: null,
};

export const modalRedirectSlice = createSlice({
  name: "modalContent",
  initialState,
  reducers: {
    SET_ACTIVE_PEN: (
      state,
      action: PayloadAction<ActivePen | null>
    ) => {
      state.activePen = action.payload;
    },
  },
});

export const { SET_ACTIVE_PEN } = modalRedirectSlice.actions;
export default modalRedirectSlice.reducer;